import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Banner } from '../interfaces/banner';

@Injectable({
  providedIn: 'root'
})
export class BannersService {

  constructor(private http: HttpClient) { }

  getActiveBanners() {
    return this.http.get<Banner[]>(environment.apiUrl + 'banners/active');
  }
}
